import { Component, OnInit, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslateService, Translation } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'ncp-patient',
  imports: [
    DatePipe,
    RouterOutlet
  ],
  templateUrl: './patient.component.html',
  styleUrl: './patient.component.scss',
})
export class PatientComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  protected patient: any;
  protected translations: Translation = this.translate.instant('patient');
  protected selectedCountry: any;

  ngOnInit(): void {
    this.patient = JSON.parse(
      sessionStorage.getItem('euPatient') || '{}'
    );

    this.selectedCountry = JSON.parse(
      sessionStorage.getItem('selectedCountry') || '{}'
    );

    this.translate.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.translations = this.translate.instant('patient');
      });
  }
}
